import { render, staticRenderFns } from "./PoolView.vue?vue&type=template&id=23dbd562&"
import script from "./PoolView.vue?vue&type=script&lang=js&"
export * from "./PoolView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports